/** Kamus label hasil tool — diselaraskan dengan brofesional-app. */

export const INTERVIEW_LEVELS = {
	start: 'Belum Siap',
	grow: 'Setengah Jalan',
	almost: 'Hampir Siap',
	ready: 'Siap Tempur',
};

export const SKD_LEVELS = {
	start: 'Rookie',
	grow: 'Rising',
	almost: 'Contender',
	ready: 'Elite',
};

export const INTERVIEW_DIMENSIONS = {
	A: { name: 'Fundamental', short: 'Fundamental' },
	B: { name: 'Amazing Content', short: 'Content' },
	C: { name: 'Amazing Delivery', short: 'Delivery' },
	D: { name: 'Eksekusi & Follow Up', short: 'Eksekusi' },
	E: { name: 'Tambahan', short: 'Tambahan' },
};

export const INTERVIEW_SCALE = [
	{ value: 0, label: 'Belum tahu' },
	{ value: 1, label: 'Sudah tahu' },
	{ value: 2, label: 'Sedang latihan' },
	{ value: 3, label: 'Sudah lancar' },
];

/** 20 pernyataan Interview Readiness (urutan = indeks answers/prio). */
export const INTERVIEW_QUESTIONS = [
	{
		dim: 'A',
		statement:
			'Saya tahu tahapan rekrutmen di perusahaan target dan siapa saja personil yang akan menginterview saya (HR, user, psikolog, direksi).',
		tip: 'Petakan dulu funnel rekrutmennya: berapa tahap, siapa pihak yang terlibat, dan apa yang dicari di tiap tahap.',
	},
	{
		dim: 'A',
		statement:
			'Saya sudah riset perusahaan: profil, produk, berita terbaru, core values, dan tugas pokok fungsi posisi yang saya lamar.',
		tip: 'Luangkan 30 menit untuk riset: profil dan produk perusahaan, berita 3 bulan terakhir, core values, dan tugas pokok fungsi posisinya.',
	},
	{
		dim: 'A',
		statement: 'Saya bisa menyebut alasan spesifik kenapa memilih perusahaan dan posisi ini.',
		tip: 'Ganti alasan template ("ingin berkembang") dengan alasan yang spesifik hanya cocok untuk perusahaan dan posisi ini.',
	},
	{
		dim: 'A',
		statement:
			'Saya tahu kesalahan yang paling sering membuat kandidat gugur di interview HR, user, psikolog, juga BOD, dan saya akan menghindarinya.',
		tip: 'Pelajari kesalahan fatal kandidat di setiap tahap interview, dari telat, ghosting sampai jawaban yang tidak nyambung.',
	},
	{
		dim: 'B',
		statement:
			'Perkenalan diri saya sudah tersusun: singkat, padat, meyakinkan, menjual, unik, dan memakai jurus Pansos.',
		tip: 'Susun perkenalan diri 90–120 detik dengan jurus Pansos: sisipkan cantolan yang mempermudah kamu untuk diingat.',
	},
	{
		dim: 'B',
		statement: 'Saya punya minimal 3 cerita pengalaman dalam format STAR, lengkap dengan angka ukurannya.',
		tip: 'Tulis bank cerita STAR. Fokus di bagian Action dan akhiri setiap cerita dengan hasil yang terukur.',
	},
	{
		dim: 'B',
		statement: 'Jawaban saya menggunakan jurus Deduktif, Numerik, dan Efisien.',
		tip: 'Latih jurus Deduktif, Numerik, dan Efisien: langsung ke inti, pakai angka, dan selesai dalam 1–2 menit.',
	},
	{
		dim: 'B',
		statement: 'Saya sudah menyiapkan jawaban untuk pertanyaan-pertanyaan unik yang jarang diketahui banyak orang.',
		tip: 'Kumpulkan pertanyaan-pertanyaan unik, lalu siapkan outline jawabannya satu per satu.',
	},
	{
		dim: 'C',
		statement: 'Saya bisa menjawab tanpa banyak filler words ("eee", "anu") dan tanpa nge-blank.',
		tip: 'Sinkronkan otak dan mulut: jeda sejenak sebelum menjawab, dan pakai napas 1-4-2 saat gugup.',
	},
	{
		dim: 'C',
		statement: 'Suara saya jelas, tempo terjaga, dan intonasi meyakinkan.',
		tip: 'Rekam suaramu saat latihan, perbaiki volume, tempo, jeda, dan penekanan di kata kunci.',
	},
	{
		dim: 'C',
		statement: 'Saya siap mengatur kontak mata dan bahasa tubuh saat bicara.',
		tip: 'Latih triangle technique untuk kontak mata dan jaga postur tegak dengan tangan terbuka.',
	},
	{
		dim: 'C',
		statement: 'Saya sudah pernah simulasi interview atau merekam diri sendiri, lalu mengevaluasinya.',
		tip: 'Ikuti program latihan 14 hari: simulasi, rekam, evaluasi dengan checklist, lalu perbaiki.',
	},
	{
		dim: 'D',
		statement:
			'Pakaian, dokumen, dan rute (atau perangkat untuk interview online) sudah siap sehari sebelumnya.',
		tip: 'Pakai checklist H-1: undangan, rute, dokumen, pakaian, serta tes kamera dan internet untuk interview online.',
	},
	{
		dim: 'D',
		statement: 'Saya tahu apa yang harus dilakukan di 7 detik pertama: masuk ruangan, menyapa, dan duduk.',
		tip: 'Latih tips dan trik masuk ruangan interview: ketuk, salam, senyum, dan cara duduk.',
	},
	{
		dim: 'D',
		statement: 'Saya tahu cara menutup interview dengan baik, termasuk menanyakan kapan hasil diumumkan.',
		tip: 'Siapkan kalimat penutup yang berkesan dan tanyakan kapan konfirmasi hasil diberikan.',
	},
	{
		dim: 'D',
		statement: 'Saya tahu kapan dan bagaimana mengirim ucapan terima kasih serta follow up yang sopan.',
		tip: 'Kirim ucapan terima kasih di hari H atau H+1, dan follow up maksimal dua kali.',
	},
	{
		dim: 'E',
		statement:
			'Saya tahu perbedaan pertanyaan HR, user, psikolog, dan BOD, serta bisa menyesuaikan jawaban saya.',
		tip: 'Pelajari apa yang dicari tiap pewawancara: HR, user, psikolog, dan BOD punya fokus penilaian yang berbeda.',
	},
	{
		dim: 'E',
		statement: 'Saya bisa tetap tenang dan terstruktur saat mendapat pertanyaan di luar prediksi.',
		tip: 'Latih memecah pertanyaan besar jadi kata kunci penting dan sebutkan asumsimu jika diperlukan.',
	},
	{
		dim: 'E',
		statement: 'Saya bisa memakai kerangka berpikir (misalnya 5 Whys, SWOT, PDCA) untuk menjawab studi kasus.',
		tip: 'Kuasai lima framework berpikir dan latih memakainya untuk satu kasus setiap hari.',
	},
	{
		dim: 'E',
		statement: 'Saya tahu cara tampil menonjol di group discussion tanpa mendominasi.',
		tip: 'Pahami peran-peran di group discussion dan apa yang dinilai asesor, lalu latih bersama teman.',
	},
];

export const SKD_SECTIONS = {
	prep: 'Persiapan Belajar',
	twk: 'TWK (Wawasan Kebangsaan)',
	tiu: 'TIU (Intelegensi Umum)',
	tkp: 'TKP (Karakteristik Pribadi)',
};

export const LOVE_LANGUAGES = {
	W: { id: 'Kata-kata Afirmasi', en: 'Words of Affirmation' },
	Q: { id: 'Waktu Berkualitas', en: 'Quality Time' },
	G: { id: 'Menerima Hadiah', en: 'Receiving Gifts' },
	S: { id: 'Tindakan Melayani', en: 'Acts of Service' },
	T: { id: 'Sentuhan Fisik', en: 'Physical Touch' },
};

export const PROFILE_LABELS = {
	domisili: 'Domisili',
	pendidikan: 'Pendidikan',
	rencana: 'Rencana',
};

export const labelOr = (map, key, fallback = key) => {
	if (key == null || key === '') return '-';
	return map[key]?.name || map[key]?.id || map[key] || fallback || String(key);
};

export const interviewDimLabel = (id) => INTERVIEW_DIMENSIONS[id]?.name || id || '-';

export const interviewLevelLabel = (lv) => INTERVIEW_LEVELS[lv] || lv || '-';

export const skdLevelLabel = (lv) => SKD_LEVELS[lv] || lv || '-';

export const skdSectionLabel = (id) => SKD_SECTIONS[id] || id || '-';

export const loveLanguageLabel = (key) => {
	const item = LOVE_LANGUAGES[key];
	if (!item) return key || '-';
	return `${item.id} (${item.en})`;
};

export const interviewScaleLabel = (answerIndex) => {
	const item = INTERVIEW_SCALE[answerIndex];
	return item?.label || (answerIndex == null ? '-' : String(answerIndex));
};

export const resolveInterviewPriority = (questionIndex, answers = []) => {
	const question = INTERVIEW_QUESTIONS[questionIndex];
	if (!question) {
		return {
			orderLabel: `Soal #${Number(questionIndex) + 1}`,
			dimLabel: '-',
			statement: `Indeks soal ${questionIndex}`,
			tip: null,
			answerLabel: interviewScaleLabel(answers?.[questionIndex]),
		};
	}
	return {
		orderLabel: `Soal #${questionIndex + 1}`,
		dimLabel: interviewDimLabel(question.dim),
		statement: question.statement,
		tip: question.tip,
		answerLabel: interviewScaleLabel(answers?.[questionIndex]),
	};
};

export const formatPercent = (value) => {
	if (value == null || value === '') return '-';
	const num = Number(value);
	if (Number.isNaN(num)) return String(value);
	return `${Math.round(num)}%`;
};
